const appInfo = {
    title: 'Taskpip Partner'
};
export default appInfo;

